export default function PolitiqueConfidentialite() {
  return (
    <div className="legal">
      <h1>Politique de confidentialité</h1>

      <p>
        La présente politique de confidentialité décrit la manière dont vos données personnelles sont collectées,
        utilisées et protégées lorsque vous utilisez ce site.
      </p>

      <h2>1. Informations que nous collectons</h2>
      <p>Nous pouvons collecter les informations suivantes :</p>
      <p>• Nom et prénom</p>
      <p>• Adresse email</p>
      <p>• Numéro de téléphone</p>

      <h2>2. Utilisation des données</h2>
      <p>Vos données sont utilisées pour :</p>
      <p>• Répondre à vos demandes et assurer le support client</p>
      <p>• Améliorer nos services et l’expérience utilisateur</p>
      <p>• Vous envoyer des informations ou offres (si vous avez accepté)</p>

      <h2>3. Partage des données</h2>
      <p>
        Vos données personnelles ne sont jamais vendues. Elles peuvent être partagées uniquement avec des prestataires
        techniques nécessaires au fonctionnement du site (hébergement, outils techniques), ou en cas d’obligation légale.
      </p>

      <h2>4. Sécurité des données</h2>
      <p>
        Nous mettons en place des mesures de sécurité adaptées (chiffrement, accès restreint, protections techniques)
        afin de protéger vos données contre tout accès non autorisé.
      </p>

      <h2>5. Vos droits</h2>
      <p>Conformément à la réglementation en vigueur, vous disposez des droits suivants :</p>
      <p>• Droit d’accès à vos données</p>
      <p>• Droit de rectification</p>
      <p>• Droit de suppression</p>
      <p>• Droit d’opposition à l’utilisation de vos données</p>

    
      <h2>6. Modifications</h2>
      <p>
        Cette politique peut être mise à jour à tout moment. Les modifications seront publiées sur cette page.
      </p>

      <h2>7. Contact</h2>
      <p>
        Pour toute question concernant vos données personnelles :
      </p>
      <p>📧 Nouhaylaerrayssy99@gmail.com</p>
      <p>📞 07 58 80 48 74</p>
    </div>
  );
}